import "../styles/globals.css";
import Layout from "../src/components/Layout";
import React, { useState, useEffect } from "react";
import Router, { useRouter } from "next/router";
import Head from "next/head";
import { PageLoader } from "../src/components/Loader";
import config from "../src/config/app.json";
import * as ga from "../src/helpers/ga";

const BASE_PATH = process.env.BASE_PATH;
const currentEnv = config["APIURIS"]["current"];

function MyApp({ Component, pageProps, router }) {
  const [showLoader, setShowLoader] = useState(false);
  const nextRouter = useRouter();

  useEffect(() => {
    if (currentEnv !== "live") {
      const handleRouteChange = (url) => {
        ga.pageview(url);
      };
      nextRouter.events.on("routeChangeComplete", handleRouteChange);
      return () => {
        nextRouter.events.off("routeChangeComplete", handleRouteChange);
      };
    }
  }, [nextRouter.events]);

  Router.events.on("routeChangeStart", () => {
    setShowLoader(true);
  });

  Router.events.on("routeChangeComplete", () => {
    setShowLoader(false);
  });

  return (
    <>
      <Head>
        <title>Free and Customizable Templates - Picmaker</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
        ></meta>
        <link rel="manifest" href={`${BASE_PATH}/manifest.json`} />
        <meta name="theme-color" content="#f86a6e" />
        <link rel="apple-touch-icon" href={`${BASE_PATH}/images/Logo.svg`} />
        <meta name="apple-mobile-web-app-status-bar" content="#f86a6e" />
        <meta name="msvalidate.01" content="F6B6298C9E6300C2ED7C035716DC9B55" />
        <meta
          name="google-site-verification"
          content="m2hygtIjgJn4QlOm-iLYTJ8XJxYBSKCkEd6W5l_3Gto"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@PicmakerHQ" />
        <meta name="twitter:creator" content="@PicmakerHQ" />
      </Head>
      <React.Fragment key={router.route}>
        <>
          <Layout>
            {showLoader ? (
              <PageLoader origin="page-loading" />
            ) : (
              <Component {...pageProps} key={router.route} />
            )}
          </Layout>
        </>
      </React.Fragment>
    </>
  );
}

export default MyApp;
